module.exports = __webpack_public_path__ + "assets/c4dd2ade7424ac033cfb16a372cf2eb5.png";